import { Navigate, Route, Routes } from 'react-router-dom'
import { FINANCIAL_TABS } from '../constants'
import { FINANCIAL_ROUTES } from './routes'
import { useSelector } from 'react-redux'
import { getUser } from '../../../redux/store/user/getters'

export const FinancialsRouter = () => {
  const user = useSelector(getUser)
  return (
    <Routes>
      {FINANCIAL_ROUTES.map((route) => (
        <Route key={route.path} path={route.path} element={<route.component />}>
          <Route path={`:type`} element={<route.component />} />
        </Route>
      ))}
      <Route
        index
        element={
          <Navigate
            to={user?.gpo ? FINANCIAL_TABS[1].key : FINANCIAL_TABS[0].key}
            replace
          />
        }
      />
    </Routes>
  )
}
